import * as React from 'react';
import { Droppable } from 'react-beautiful-dnd';

import './droppable-attachment-container.scss';

type Props = {
  id: number,
  analyticId: number,
  children: React.ReactNode
};

const DroppableAttachmentContainer = ({
  id,
  analyticId,
  children
}: Props) => (
  <Droppable
    key={`metrics-droppable-${id}|${analyticId}`}
    droppableId={`metrics-table-row-${id}|${analyticId}`}
  >
    {(provided, snapshot) => (
      <div
        {...provided.droppableProps}
        ref={provided.innerRef}
        className={(snapshot.isDraggingOver) ? 'droppable-attachment-container__drop-target' : ''}
      >
        {children}
        <div className="droppable-attachment-container__placeholder">
          {provided.placeholder}
        </div>
      </div>
    )}
  </Droppable>
);

export default DroppableAttachmentContainer;
